import theme from "@shared/utils/themeColors";
import React from "react";

interface UpvoteButtonProps {
  count: number;
  isUpvoted?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

/**
 * Reusable upvote button component
 */
export const UpvoteButton: React.FC<UpvoteButtonProps> = ({
  count,
  isUpvoted = false,
  onClick,
  className = "",
}) => {
  return (
    <div className={`shrink-0 ${className}`}>
      <button
        onClick={onClick}
        className={`text-xs font-semibold text-center h-12 w-12 border ${
          isUpvoted
            ? "border-blue-500/60 shadow-blue-500/20"
            : `${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600`
        } rounded-lg flex flex-col justify-center items-center`}
      >
        <svg
          className={`inline-flex ${
            isUpvoted ? theme.bg.upvote : "fill-gray-400 dark:fill-gray-500"
          } mt-1.5 mb-1.5`}
          width="12"
          height="6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m0 6 6-6 6 6z" />
        </svg>
        <div>{count}</div>
      </button>
    </div>
  );
};

export default UpvoteButton;
